
import {defineComponent} from 'vue';
export default defineComponent({
  props: {
    title:{type:String,required:true}, count:{type:Number,default:null}, modelValue:{type:Boolean,default:false}
  },
  emits:['update:modelValue']
});
